import { Navigate } from 'react-router'
import { useAuthStore } from '@/features/auth/store/store.ts'
import { getLuxeRedirectPath } from '@/features/luxe-submissions/utils'
import { routes } from '@/routes'

function LuxeSubmissionsIndex() {
	const user = useAuthStore((state) => state.user)

	const redirectPath =
		getLuxeRedirectPath(user?.role) ??
		routes.LUXE_SUBMISSIONS_QUEUE_VISUAL_VETTING.handle.fullPath

	return <Navigate replace to={redirectPath} />
}

export { LuxeSubmissionsIndex }
